module.exports = __webpack_public_path__ + "media/images/open_x_small_logo-f07fe5e267533914cd96f119ee6e0b19.png";